import { useCallback } from 'react'
import { type UserId, type UserData, type UserGetInput, type UserGetSuccess, HOUR } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { userKey } from '../keys'
import { useServerRequest } from '../api'

export function useFetchUser(): (userId: UserId) => Promise<UserData> {
  const serverRequest = useServerRequest<UserGetInput, UserGetSuccess>('/user/get')
  const queryClient = useQueryClient()
  return useCallback(
    async (userId: UserId): Promise<UserData> => {
      return queryClient.fetchQuery({
        queryKey: userKey(userId),
        staleTime: HOUR,
        queryFn: async () => {
          const { user } = await serverRequest({ userId })
          return user
        },
      })
    },
    [queryClient, serverRequest]
  )
}
